export function parseDateOnly(raw: string | null | undefined): Date | undefined {
  if (typeof raw !== 'string') return undefined;
  const value = raw.trim();
  const dayFirst = /^(\d{2})([/.])(\d{2})\2(\d{4})$/.exec(value);
  const yearFirst = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const monthOnly = /^(\d{2})\/(\d{4})$/.exec(value);

  let year: number;
  let month: number;
  let day: number;
  if (dayFirst) {
    day = Number(dayFirst[1]);
    month = Number(dayFirst[3]);
    year = Number(dayFirst[4]);
  } else if (yearFirst) {
    year = Number(yearFirst[1]);
    month = Number(yearFirst[2]);
    day = Number(yearFirst[3]);
  } else if (monthOnly) {
    year = Number(monthOnly[2]);
    month = Number(monthOnly[1]);
    day = 1;
  } else {
    return undefined;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  // Date.UTC normalizes out-of-range components; reject those rather than guessing.
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return undefined;
  }
  return date;
}
